<script>
export default {
    data () {
        return {
            dis_data:undefined
        }
    },
    methods: {
        changeStatusDiscipline(dat){

            var vm = this;
            this.dis_data  = vm
            var dis_data_test = this.dis_data.discepline.uid
            // console.log('aspaspaspasppasp',this.dis_data.discepline)
            var changeDis = {
                key:null,
                status:null,
                is_parent:true,
            }
            // console.log(this.disceplines)

            this.disceplines.forEach(function(dis,index){


                if(dis.uid == dis_data_test){
                    changeDis.key = index
                    changeDis.status = dat
                    changeDis.is_parent= true
                }

                if(dis.children.length){

                    dis.children.forEach(function(child,i){
                        if(child.uid == dis_data_test){
                            changeDis.key = index
                            changeDis.child = i
                            changeDis.status = dat
                            changeDis.is_parent= false
                        }
                    });

                }
            });
            var check_null = changeDis.key !== null && changeDis.status !== null
            if(check_null && changeDis.is_parent){
                this.$store.commit('regis_discepline/CHANGE_STATUS_DISCIPLNE',changeDis)
            }
            else if(check_null && changeDis.is_parent==false){
                this.$store.commit('regis_discepline/CHANGE_STATUS_DISCIPLNE_CHILD',changeDis)
            }
        },
        CardchangeStatusDiscipline(val){

            var vm = this;
            var changeDis = {
                key:null,
                status:null,
                is_parent:true,
            }
            // console.log(this.disceplines)
            // console.log(vm)
            this.disceplines.forEach(function(dis,index){


                if(dis.uid == vm.discipline.uid){
                    changeDis.key = index
                    changeDis.status = val
                    changeDis.is_parent= true
                }

                if(dis.children.length){

                    dis.children.forEach(function(child,i){
                        if(child.uid == vm.discipline.uid){
                            changeDis.key = index
                            changeDis.child = i
                            changeDis.status = val
                            changeDis.is_parent= false
                        }
                    });

                }
            });
            var check_null = changeDis.key !== null && changeDis.status !== null
            if(check_null && changeDis.is_parent){
                this.$store.commit('regis_discepline/CHANGE_STATUS_DISCIPLNE',changeDis)
            }
            else if(check_null && changeDis.is_parent==false){
                this.$store.commit('regis_discepline/CHANGE_STATUS_DISCIPLNE_CHILD',changeDis)
            }
        },
        changeTeacherLanguage(val){

            var vm = this;
            var changeDis = {
                key:null,
                type_load:null,
                is_parent:true,
            }
            // console.log(this.disceplines)
            // console.log(vm)
            this.disceplines.forEach(function(dis,index){


                if(dis.uid == vm.discipline.uid){
                    changeDis.key = index
                    changeDis.type_load = val
                    changeDis.is_parent= true
                }

                if(dis.children.length){

                    dis.children.forEach(function(child,i){
                        if(child.uid == vm.discipline.uid){
                            changeDis.key = index
                            changeDis.child = i
                            changeDis.type_load = val
                            changeDis.is_parent= false
                        }
                    });

                }
            });
            var check_null = changeDis.key !== null && changeDis.type_load !== null
            if(check_null && changeDis.is_parent){
                this.$store.commit('regis_discepline/CHANGE_TEACHER_LANGUAGE',changeDis)
            }
            else if(check_null && changeDis.is_parent==false){
                this.$store.commit('regis_discepline/CHANGE_TEACHER_LANGUAGE_CHILD',changeDis)
            }
        },
    }

}
</script>
